// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Scroll bar stylings */\n::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n    background: var(--lightestgrey);\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 5px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n", ""]);
// Exports
module.exports = exports;
